import styled from "styled-components";

const DashboardContainer = styled.div`
  margin-right: 40px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

export { DashboardContainer, HeaderContainer };
